export const isNuEar = (siteId: number) => {
    return siteId === 3;
};
